import { IRest } from './rest.interface';


export class SharingGroup implements IRest {
  className = 'Grupo de compartilhamento';

  id: string;
  workspaceId: string;
  name: string;

  members: any[] = [];

  constructor(data?: any) {
    if (data) this.Deserialize(data);
  }

  Serialize() {
    const out = {
      id: this.id,
      workspaceId: this.workspaceId,
      name: this.name,
    };
    return out;
  }

  Deserialize(data: any) {
    if (data) {
      this.id = data['id'] || undefined;
      this.workspaceId = data['workspaceId'] || undefined
      this.name = data['name'] || '-'
    }
    return this;
  }
}
